import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { guest: true, title: 'auth.login' },
  },
  {
    path: '/',
    redirect: '/login',
    meta: { guest: true },
  },
  {
    path: '/:appId',
    component: () => import('@/components/layout/AppLayout.vue'),
    meta: { auth: true },
    children: [
      {
        path: '',
        redirect: (to) => ({ name: 'services', params: { appId: to.params.appId as string } }),
      },
      {
        path: 'services',
        name: 'services',
        component: () => import('@/views/ServicesView.vue'),
        meta: { title: 'nav.resources' },
      },
      {
        path: 'services/:serviceId',
        name: 'service-detail',
        component: () => import('@/views/ServiceDetailView.vue'),
        meta: { title: 'nav.resources' },
      },
      {
        path: 'deployments',
        name: 'deployments',
        component: () => import('@/views/DeploymentsView.vue'),
        meta: { title: 'nav.deployments' },
      },
      {
        path: 'deployments/:deploymentId',
        name: 'deployment-detail',
        component: () => import('@/views/DeploymentDetailView.vue'),
        meta: { title: 'nav.deployments' },
      },
      {
        path: 'config',
        name: 'config',
        component: () => import('@/views/ConfigView.vue'),
        meta: { title: 'nav.config' },
      },
      {
        path: 'config/:configSetId',
        name: 'config-detail',
        component: () => import('@/views/ConfigDetailView.vue'),
        meta: { title: 'nav.config' },
      },
      {
        path: 'observability',
        name: 'observability',
        component: () => import('@/views/ObservabilityView.vue'),
        meta: { title: 'nav.observability' },
      },
    ],
  },
  {
    // 管理控制台：账户级（billing 覆盖名下所有 orgs），不挂在 org/workspace 段下。
    path: '/admin',
    component: () => import('@/components/layout/AppLayout.vue'),
    meta: { auth: true },
    children: [
      {
        path: '',
        redirect: '/admin/billing',
      },
      {
        path: ':tab',
        component: () => import('@/views/AdminView.vue'),
        meta: { auth: true, title: 'nav.administration' },
      },
    ],
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('@/views/OnboardingView.vue'),
    meta: { auth: true, title: 'onboarding.title' },
  },
  {
    // Public pricing page (issue #37): accessible to guests AND signed-in
    // users — no auth/guest meta so the guards leave it alone.
    path: '/pricing',
    name: 'pricing',
    component: () => import('@/views/PricingView.vue'),
    meta: { title: 'pricing.title' },
  },
  {
    // Legal pages (#57 Phase D): public, standalone shell, placeholder bodies
    // pending legal review.
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/LegalView.vue'),
    meta: { title: 'legal.terms.title' },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/LegalView.vue'),
    meta: { title: 'legal.privacy.title' },
  },
  {
    path: '/refund-policy',
    name: 'refund-policy',
    component: () => import('@/views/LegalView.vue'),
    meta: { title: 'legal.refund.title' },
  },
  {
    path: '/cli/authorize',
    name: 'cli-authorize',
    component: () => import('@/views/CliAuthorizeView.vue'),
    meta: { auth: true, title: 'cliAuthorize.title' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
    meta: { guest: true, title: 'errors.notFoundTitle' },
  },
]
